// import { BleClient } from '@capacitor-community/bluetooth-le';
import { IonButton, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonModal, IonPage, IonRow, IonToast, IonToolbar, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { alertCircleOutline, logoWhatsapp } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../contexts/MessageContext';
import { cadastrarELogarDireto, empresaCarregar, requestService } from '../../../Utils/Services';
import Carrinho from '../Carrinho/Carrinho';
import InformacoesEmpresa from '../InformacoesEmpresa/InformacoesEmpresa';
import OrdensProdutosCompor from '../OrdensProdutosCompor/OrdensProdutosCompor';
import "./Pedido.css";

type Props = {
  id: any;
  nome: any;
};

const Pedido: React.FC<Props> = (props: Props) => {

  // Hooks de navegação
  const history = useHistory<any>();
  const [showModalCarrinho, setShowModalCarrinho] = useState(!true);

  // Estados de modais e alertas
  const [mostrarAlerta] = useIonAlert();

  // Estados relacionados a loading e feedback visual
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  // Estados de dados e listas
  const { listaItemProdutos, setListaItemProdutos } = useContext(MessageContext);
  const [valorTotalProdutos, setValorTotalProdutos] = useState<any>();

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  // Referências
  const contentCatalogoRef = useRef<any>(null);
  const contentRef = useRef<HTMLIonContentElement | null>(null);

  const [showModalInformacoes, setShowModalInformacoes] = useState(false);
  const isMobile = window.matchMedia("(max-width: 767px)").matches;


  // no topo do componente
  const [showHorarioInfo, setShowHorarioInfo] = useState(true);

  // ===== ESTADOS =====
  const [selectedCategoria, setSelectedCategoria] = useState<string>('');
  const [isManualScrolling, setIsManualScrolling] = useState(false);

  // ===== REF =====
  const categoriasRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    if (!selectedCategoria || !categoriasRef.current) return;

    const btn = categoriasRef.current.querySelector(
      `[data-categoria="${selectedCategoria}"]`
    ) as HTMLElement | null;

    if (btn && categoriasRef.current) {
      const container = categoriasRef.current;
      const btnRect = btn.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const offset = btnRect.left - containerRect.left + container.scrollLeft;

      container.scrollTo({
        left: offset - container.clientWidth / 2 + btnRect.width / 2,
        behavior: "smooth",
      });
    }
  }, [selectedCategoria]);

  const scrollToCategory = async (categoryName: string) => {
    setIsManualScrolling(true);
    setSelectedCategoria(categoryName);

    const el = document.getElementById(`category-${categoryName}`);
    if (!el) {
      setTimeout(() => setIsManualScrolling(false), 300);
      return;
    }

    try {
      // tenta pegar o elemento real que faz o scroll dentro do IonContent
      const scrollEl: HTMLElement | null = contentRef.current ? await contentRef.current.getScrollElement() : null;

      // altura da base do header na viewport
      const headerEl = document.querySelector('ion-header') as HTMLElement | null;
      const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
      const EXTRA_TOP = 6; // ajuste fino se precisar

      if (scrollEl) {
        // rects relativos à viewport
        const scrollRect = scrollEl.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();

        // queremos que o topo do elemento fique logo abaixo do header:
        const desiredTopInViewport = headerBottom + EXTRA_TOP;
        // diferença em px entre a posição atual do elemento e a posição desejada (na viewport)
        const deltaViewport = elRect.top - desiredTopInViewport;

        // converte para target absoluto em scrollTop do scrollEl
        const target = Math.max(0, scrollEl.scrollTop + deltaViewport);

        console.log('[SCROLL] category:', categoryName, {
          elOffsetTop: el.offsetTop,
          elRectTop: elRect.top,
          headerBottom,
          deltaViewport,
          scrollTop: scrollEl.scrollTop,
          target
        });

        // faz o scroll no container interno (mais confiável)
        scrollEl.scrollTo({ top: target, behavior: 'smooth' });
      } else {
        // fallback: usa scrollIntoView + ajusta scroll-margin-top para compensar o header
        el.style.scrollMarginTop = `${headerBottom + EXTRA_TOP}px`;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (err) {
      console.warn('scrollToCategory error', err);
    } finally {
      // libera o spy depois do scroll (pequeno delay)
      setTimeout(() => setIsManualScrolling(false), 400);
    }
  };

  // ===== SCROLL SPY =====
  const handleContentScroll = (e: any) => {
    if (isManualScrolling) return;

    const scrollTop = e?.detail?.scrollTop ?? 0;

    // Controla a visibilidade do conteúdo de horário baseado no scroll
    const threshold = 100; // pixels de scroll para esconder o conteúdo
    setShowHorarioInfo(scrollTop < threshold);

    const allCategories =
      dadosEmpresa?.categoriaProdutos?.filter((c: any) => {
        // Filtro 1: Não mostrar complementos
        if (c.tipo === "complementos") return false;

        // Filtro 2: Verificar se a categoria tem produtos disponíveis
        return shouldShowCategory(c);
      }) || [];

    const headerEl = document.querySelector('ion-header') as HTMLElement | null;
    const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;

    // Se ainda não temos categoria selecionada, seleciona a primeira visível
    if (!selectedCategoria && allCategories.length > 0) {
      const firstCategory = allCategories[0];
      const firstEl = document.getElementById(`category-${firstCategory.nome}`);
      if (firstEl) {
        const firstRect = firstEl.getBoundingClientRect();
        if (firstRect.bottom > headerBottom) {
          setSelectedCategoria(firstCategory.nome);
          return;
        }
      }
    }

    if (selectedCategoria) {
      const currentIndex = allCategories.findIndex((cat: any) => cat.nome === selectedCategoria);

      // Verifica se alguma categoria anterior está começando a aparecer (scroll para cima)
      for (let i = currentIndex - 1; i >= 0; i--) {
        const prevCat = allCategories[i];
        const prevEl = document.getElementById(`category-${prevCat.nome}`);
        if (prevEl) {
          const prevRect = prevEl.getBoundingClientRect();
          // Se a categoria anterior está aparecendo na tela
          if (prevRect.bottom > headerBottom && prevRect.top < window.innerHeight) {
            setSelectedCategoria(prevCat.nome);
            return;
          }
        }
      }

      // Verifica se a categoria atual ainda está visível
      const currentEl = document.getElementById(`category-${selectedCategoria}`);
      if (currentEl) {
        const currentRect = currentEl.getBoundingClientRect();

        // Se a categoria atual ainda está visível na tela, mantém
        if (currentRect.bottom > headerBottom && currentRect.top < window.innerHeight) {
          return; // Mantém a categoria atual
        }

        // Se a categoria atual saiu completamente por cima (scroll para baixo)
        if (currentRect.bottom <= headerBottom) {
          // Procura a próxima categoria que está visível
          for (let i = currentIndex + 1; i < allCategories.length; i++) {
            const nextCat = allCategories[i];
            const nextEl = document.getElementById(`category-${nextCat.nome}`);
            if (nextEl) {
              const nextRect = nextEl.getBoundingClientRect();
              // Se a próxima categoria está visível, seleciona ela
              if (nextRect.bottom > headerBottom && nextRect.top < window.innerHeight) {
                setSelectedCategoria(nextCat.nome);
                return;
              }
            }
          }
        }
      }
    }
  };

  const getHeaderOffset = () => {
    // pega o ion-header (inclui ambos toolbars) e usa a altura real
    const headerEl = document.querySelector('ion-header') as HTMLElement | null;
    return headerEl ? headerEl.getBoundingClientRect().height : 0;
  };

  // Funções de rolagem
  const scrollToTop = () => {
    if (contentRef.current) {
      contentRef.current.scrollToTop();
    }
  };

  const scrollToCatalogo = () => {
    if (contentCatalogoRef.current) {
      contentCatalogoRef.current.scrollIntoView();
    }
  };

  useIonViewDidEnter(() => {

    const urlParams = new URLSearchParams(window.location.search);
    const empresaid = urlParams.get('empresaid'); // Obtém o valor do parâmetro 'convite'
    console.log("empresaid:", empresaid);

    console.log("entrou no useIonViewDidEnter");
    if (empresaid) {
      scrollToTop();
      // carregarEmpresa(empresaid);
    }
  });

  useEffect(() => {
    console.log("entrou useEffect");
    carregarSomasItemProdutos();
  }, [listaItemProdutos]);

  function carregarSomasItemProdutos() {

    // Calcula a nova soma dos valores após a remoção
    const totalValor = listaItemProdutos.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
    console.log("Nova soma dos valores:", totalValor);

    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));

  }

  async function carregarEmpresa(loja: any) {

    const consultar = async () => {

      // Verificar se empresaid já tem o prefixo "empresa#", caso não tenha, concatenar
      const empresaidFormatado = loja.startsWith('empresa#') ? loja : `empresa#${loja}`;

      requestService(empresaCarregar.url.replace("{id}", empresaidFormatado.replace(/#/g, '%23')), {
        method: empresaCarregar.method
      },
        history,
        (response: any) => {
          console.log("carregou empresa pedido", response.Item);
          setDadosEmpresa(response.Item);
          localStorage.setItem("empresaid", response.Item.pk);
          localStorage.setItem("empresanome", response.Item.empresaNome);

          if (response.Item.estrangeiro) {
            localStorage.setItem("estrangeiro", "true");
          } else {
            localStorage.removeItem("estrangeiro");
          }

          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
        });

    }

    await consultar();
  }

  async function adicionarItem(produto: any, avancarCarrinho: boolean = false) {

    if (produto) {

      let updatedList = [...listaItemProdutos, produto];

      setListaItemProdutos(updatedList);


      let totalValor = updatedList.reduce((total: any, item: any) => {
        const itemValorNumerico = parseFloat(
          item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
        );
        return total + itemValorNumerico;
      }, 0);

      setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

      setTextToast("Item adicionado com sucesso.");
      setShowToast(true);

    }

    if (avancarCarrinho) {
      setShowModalCarrinho(true);
    }

    // scrollToCatalogo();
  }

  async function closeModalInformacoes() {
    setShowModalInformacoes(false);
  }

  async function closeModalCarrinho() {
    setShowModalCarrinho(false);
    mostrarAlerta({
      backdropDismiss: false,
      header: 'Pedido realizado com sucesso!',
      message: 'Deseja <strong>acompanhar</strong> seu <strong>pedido</strong>?',
      buttons: [
        {
          text: 'Agora não',
          role: 'cancel',
        },
        {
          text: 'Acompanhar pedido',
          cssClass: 'primary',
          handler: async () => {
            // Faz login automático antes de redirecionar
            await fazerLoginAutomatico();
          }
        }
      ],
      onDidDismiss: (e: any) => console.log('did dismiss'),
    });
  }

  async function closeModalCarrinhoVoltar() {
    setShowModalCarrinho(false);
  }

  async function fazerLoginAutomatico() {
    const nomeLocal = (localStorage.getItem("nome") || "").trim();
    const telefoneLocal = (localStorage.getItem("telefone") || "").trim();

    if (!nomeLocal || !telefoneLocal) {
      setTextToast("Erro ao fazer login automático. Dados incompletos.");
      setShowToast(true);
      return;
    }

    setShowLoading(true);

    try {
      const body = {
        nome: nomeLocal,
        telefone: telefoneLocal,
      };

      const response = await fetch(cadastrarELogarDireto.url, {
        method: cadastrarELogarDireto.method,
        headers: {
          'Content-Type': 'application/json'
        } as HeadersInit,
        credentials: 'include',
        body: JSON.stringify(body)
      });

      const retorno = await response.json();

      if (response.status === 200 || response.status === 201) {
        console.log("Login automático realizado com sucesso:", retorno);

        // Armazena o token se retornar
        if (retorno.token) {
          localStorage.setItem("token", "token=" + retorno.token);
        }

        // Redireciona para a página Inicio
        history.replace("/cliente/ordens");
      } else {
        history.replace("/novo-login");
      }
    } catch (error) {
      history.replace("/novo-login");
    } finally {
      setShowLoading(false);
    }
  }

  const calcularHorarioFinal = (start: any, duration: any) => {
    const [hours, minutes] = start.split(':').map(Number);
    const endMinutes = minutes + duration;
    const endHours = hours + Math.floor(endMinutes / 60);
    const finalMinutes = endMinutes % 60;
    return `${endHours.toString().padStart(2, '0')}:${finalMinutes.toString().padStart(2, '0')}`;
  };

  const formatarHorario = (horario: string) => {
    return horario.split(":").slice(0, 2).join(":");
  };

  // certifique-se que contentRef existe:
  // const contentRef = useRef<HTMLIonContentElement | null>(null);

  // ✅ Função para verificar se uma categoria deve ser exibida
  const shouldShowCategory = (categoria: any) => {
    if (!dadosEmpresa?.catalogoProdutos) return false;

    // Encontrar produtos desta categoria
    const produtosDaCategoria = dadosEmpresa.catalogoProdutos.filter((produto: any) =>
      produto.categoria === categoria.nome
    );

    // Verificar se tem pelo menos um produto disponível
    const produtosDisponiveis = produtosDaCategoria.filter((produto: any) => {
      // 1. Verificar se tem internet=true
      if (!produto?.internet) return false;

      // 2. Se controlarEstoque=true, verificar quantidadeEstoque
      if (produto?.controlarEstoque === true) {
        const qtdStr = produto?.quantidadeEstoque ?? "0";
        const quantidade = parseInt(qtdStr, 10) || 0;
        if (quantidade <= 0) return false;
      }

      return true;
    });

    return produtosDisponiveis.length > 0;
  };

  // ===== COMPONENTE DE NAVEGAÇÃO DE CATEGORIAS =====
  const renderCategoriaButtons = () => {
    if (dadosEmpresa && dadosEmpresa.categoriaProdutos) {

      return (
        <div style={{ width: '100%', display: 'flex', padding: '0px 10px', flexDirection: 'column', backgroundColor: 'white', color: '#666' }}>
          {/* Categories row */}
          <div ref={categoriasRef} style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', width: '100%' }}>
            {dadosEmpresa.categoriaProdutos.filter((value: any) => {
              // Filtro 1: Não mostrar complementos
              if (value.tipo === "complementos") return false;

              // Filtro 2: Verificar se a categoria tem produtos disponíveis
              return shouldShowCategory(value);
            }).map((item: any, index: any) => (
              <IonCol size="auto" key={index} style={{
                flex: '0 0 auto',
                textAlign: 'center',
                padding: '12px 16px',
                minHeight: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
                data-categoria={item.nome} // 👈 importante para localizar depois
                onClick={() => { scrollToCategory(item.nome) }}>

                <IonLabel style={{
                  fontSize: '14px',
                  color: selectedCategoria == item.nome ? '#ff0000' : '#666',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  // backgroundColor: selectedCategoria == item.nome ? '#fff5f5' : 'transparent',
                  // transition: 'all 0.2s ease'
                }}>
                  {item.nomeCategoria || item.nome}
                </IonLabel>
              </IonCol>
            ))}
          </div>

        </div>
      );
    }
  };

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  // ===== COMPONENTE DE INFORMAÇÕES DA EMPRESA =====
  const renderEmpresaInfo = () => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '20px 16px',
          backgroundColor: '#fff',
          cursor: 'pointer'
        }}
        onClick={() => setShowModalInformacoes(true)}
      >
        {/* Logo da empresa */}
        {dadosEmpresa?.urlLogo && (
          <img
            src={dadosEmpresa.urlLogo}
            alt="Logo da empresa"
            style={{
              width: '60px',
              height: '60px',
              objectFit: 'cover',
              marginRight: '12px',
              borderRadius: '4px'
            }}
          />
        )}

        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#000',
            marginBottom: '2px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            lineHeight: '1'
          }}>
            {dadosEmpresa?.empresaNome}
          </div>

          {dadosEmpresa?.empresaTelefone && (
            <div style={{
              fontSize: '14px',
              color: '#333',
              fontWeight: 'normal',
              marginTop: '0px',
              lineHeight: '1',
              marginBottom: '0px'
            }}>
              {formataTelefone(dadosEmpresa.empresaTelefone)}
            </div>
          )}
        </div>

        {/* Ícone de seta para indicar que é clicável */}
        <div style={{
          color: '#666',
          fontSize: '16px',
          fontWeight: 'bold'
        }}>
          ›
        </div>
      </div>
    );
  };

  // ===== COMPONENTE DE INFORMAÇÕES INFERIORES (HORÁRIO, CUPOM, MÍNIMO) =====
  const renderBottomInfo = () => {
    // Lógica do horário (reutilizando do renderHorarioInfo)
    const diasSemanaNumber: any = {
      SUNDAY: 0,
      MONDAY: 1,
      TUESDAY: 2,
      WEDNESDAY: 3,
      THURSDAY: 4,
      FRIDAY: 5,
      SATURDAY: 6,
    };

    const diaAtual = new Date().getDay();
    const diaAtualTexto = Object.keys(diasSemanaNumber).find(
      (key) => diasSemanaNumber[key] === diaAtual
    );

    const diaAmanha = (diaAtual + 1) % 7;
    const amanhaTexto = Object.keys(diasSemanaNumber).find(
      (key) => diasSemanaNumber[key] === diaAmanha
    );

    const horariosHoje = dadosEmpresa?.horarios?.filter(
      (horario: any) => horario.dayOfWeek === diaAtualTexto
    ) || [];

    const horariosAmanha = dadosEmpresa?.horarios?.filter(
      (horario: any) => horario.dayOfWeek === amanhaTexto
    ) || [];

    const agora = new Date();
    const ordenarHorarios = (a: any, b: any) => a.start.localeCompare(b.start);
    const horariosHojeOrdenados = [...horariosHoje].sort(ordenarHorarios);

    let proximoHorarioHoje: any = null;
    let estaAberto = false;

    for (const horario of horariosHojeOrdenados) {
      const [horaInicio, minutoInicio] = horario.start.split(":").map(Number);
      const inicio = new Date();
      inicio.setHours(horaInicio, minutoInicio, 0, 0);
      const fim = new Date(inicio.getTime() + horario.duration * 60000);

      if (agora >= inicio && agora <= fim) {
        estaAberto = true;
        proximoHorarioHoje = horario;
        break;
      }

      if (agora < inicio && !proximoHorarioHoje) {
        proximoHorarioHoje = horario;
      }
    }

    // Determinar texto do horário
    let textoHorario = "";
    let corHorario = "#000";

    if (estaAberto && proximoHorarioHoje) {
      textoHorario = `Aberto - fecha às ${calcularHorarioFinal(proximoHorarioHoje.start, proximoHorarioHoje.duration)}`;
      corHorario = "#28a745"; // verde
    } else if (proximoHorarioHoje) {
      textoHorario = `Fechado - abre às ${formatarHorario(proximoHorarioHoje.start)}`;
      corHorario = "#dc3545"; // vermelho
    } else if (horariosAmanha.length > 0) {
      const proximoHorarioAmanha = [...horariosAmanha].sort(ordenarHorarios)[0];
      textoHorario = `Fechado - abre amanhã às ${formatarHorario(proximoHorarioAmanha.start)}`;
      corHorario = "#dc3545"; // vermelho
    } else {
      textoHorario = "Fechado";
      corHorario = "#dc3545"; // vermelho
    }

    // Lógica da taxa de entrega (menor taxa cadastrada)
    const configuracoesEntrega = dadosEmpresa?.configuracoesEntrega || [];
    const menorTaxaEntrega = configuracoesEntrega.length > 0
      ? configuracoesEntrega.reduce((menor: any, atual: any) => {
        const valorMenor = parseFloat(menor.taxa?.replace(/\./g, '').replace(/\,/g, '.') || '0');
        const valorAtual = parseFloat(atual.taxa?.replace(/\./g, '').replace(/\,/g, '.') || '0');
        return valorAtual < valorMenor ? atual : menor;
      })
      : null;

    return (
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 10px',
        backgroundColor: '#fff',
        borderTop: '1px solid #e0e0e0'
      }}>
        {/* Coluna 1: Horário */}
        <div style={{ flex: 1, textAlign: 'left', padding: '10px' }}>
          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
            Horário
          </div>
          <div style={{ fontSize: '12px', fontWeight: 'bold', color: corHorario }}>
            {textoHorario}
          </div>
        </div>

        {/* Coluna 2: Taxa de Entrega */}
        <div style={{ flex: 1, textAlign: 'left', padding: '10px' }}>
          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
            Taxa de entrega
          </div>
          {menorTaxaEntrega ? (
            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#000' }}>
              {(() => {
                const taxaStr = (menorTaxaEntrega.taxa ?? '0').toString();
                const taxaNum = parseFloat(taxaStr.replace(/\./g, '').replace(/\,/g, '.')) || 0;
                return taxaNum <= 0 ? 'Grátis' : `A partir de R$ ${taxaStr}`;
              })()}
            </div>
          ) : (
            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#000' }}>
              Sem delivery
            </div>
          )}
        </div>

        {/* Coluna 3: Pedido Mínimo */}
        <div style={{ flex: 1, textAlign: 'left', padding: '10px' }}>
          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
            Pedido mínimo
          </div>
          <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#000' }}>
            R$ {dadosEmpresa?.pedidoMinimo ? parseFloat(dadosEmpresa.pedidoMinimo.toString()).toLocaleString('pt-br', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) : '0,00'}
          </div>
        </div>
      </div>
    );
  };

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        {/* <IonToolbar>
          <IonTitle>{dadosEmpresa?.empresaNome}</IonTitle>

          <IonButtons slot="end">
          
          </IonButtons>
        </IonToolbar> */}

        <IonToolbar>
          {/* Informações da empresa no header */}
          {dadosEmpresa && (
            <div className={`horario-container ${showHorarioInfo ? 'visible' : 'hidden'}`}>
              {renderEmpresaInfo()}
              {renderBottomInfo()}
            </div>
          )}

          {dadosEmpresa && !dadosEmpresa?.bloquearAcesso && (
            <div className={`horario-container ${showHorarioInfo ? 'hidden' : 'visible'}`}>
              {renderCategoriaButtons()}
            </div>
          )}

        </IonToolbar>
      </IonHeader>

      <IonContent
        ref={contentRef}
        fullscreen={true}          // opcional, ajuda o IonContent ocupar a área
        scrollEvents={true}       // muito importante
        onIonScroll={(e) => handleContentScroll(e)}
      >

        <IonGrid style={{ height: '100%', padding: "0px", margin: "0px" }} ref={contentCatalogoRef}>
          <IonRow style={{ height: '100%' }}>
            <IonCol style={{ height: '100%', padding: "0px", margin: "0px" }} size="12">
              {dadosEmpresa?.bloquearAcesso ? (
                <div style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  padding: '40px 20px',
                  backgroundColor: '#fff'
                }}>
                  <div style={{
                    maxWidth: '400px',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                    {/* Ícone de alerta */}
                    <div style={{
                      width: '64px',
                      height: '64px',
                      margin: '0 auto 20px',
                      backgroundColor: '#ffe5e5',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <IonIcon
                        icon={alertCircleOutline}
                        color="danger"
                        style={{
                          fontSize: '40px',
                        }}
                      />
                    </div>

                    {/* Título */}
                    <h2 style={{
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#333',
                      marginBottom: '12px',
                      lineHeight: '1.3'
                    }}>
                      Pedidos temporariamente indisponíveis
                    </h2>

                    {/* Mensagem */}
                    <p style={{
                      fontSize: '15px',
                      color: '#666',
                      lineHeight: '1.6',
                      marginBottom: '24px'
                    }}>
                      No momento, os pedidos online estão pausados para este estabelecimento.
                      Para continuar seu atendimento, fale diretamente com a loja pelo WhatsApp.
                    </p>

                    {/* Botão de WhatsApp */}
                    {dadosEmpresa?.empresaTelefone && (
                      <IonButton
                        expand="block"
                        color="success"
                        style={{
                          '--border-radius': '8px',
                          height: '48px',
                          fontWeight: '600',
                          fontSize: '15px'
                        }}
                        onClick={() => {
                          const numero = dadosEmpresa.empresaTelefone.replace(/\D/g, '');
                          window.open(`https://wa.me/${numero}`, '_blank');
                        }}
                      >
                        <IonIcon icon={logoWhatsapp} slot="start" />
                        Falar no WhatsApp
                      </IonButton>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ height: '100%' /* REMOVIDO overflow: 'auto' */ }}>
                  <OrdensProdutosCompor
                    empresa={dadosEmpresa}
                    disabled={false}
                    adicionarItem={adicionarItem}
                    {...({ selectedCategoria, onCategoriaChange: setSelectedCategoria } as any)}
                  />
                </div>
              )}
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonModal isOpen={showModalInformacoes} onDidDismiss={() => { setShowModalInformacoes(false); }}>
          <InformacoesEmpresa closeAction={closeModalInformacoes}></InformacoesEmpresa>
        </IonModal>

        <IonModal className="fullscreen-modal" isOpen={showModalCarrinho} onDidDismiss={() => { setShowModalCarrinho(false); }}>
          <Carrinho logado={false} closeAction={closeModalCarrinho} closeActionVoltar={closeModalCarrinhoVoltar}></Carrinho>
        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

      <IonFooter hidden={listaItemProdutos?.length === 0 || dadosEmpresa?.bloquearAcesso}>
        <IonToolbar
          style={{
            padding: '10px'
          }}
        >
          {/* Valor total */}
          <IonLabel style={{ fontSize: '20px', fontWeight: 'bold' }}>
            {valorTotalProdutos ? `R$ ${valorTotalProdutos}` : "R$ 0,00"}
          </IonLabel>

          {/* Botão com contador */}
          <IonButton
            slot="end"
            style={{
              height: "46px",
              fontWeight: "bold"
            }}
            onClick={async () => {
              const agora = new Date();
              const diaAtual = agora.getDay(); // 0 a 6
              const horarioAtual = agora.getHours() * 60 + agora.getMinutes(); // em minutos

              const diasSemanaNumber: any = {
                SUNDAY: 0,
                MONDAY: 1,
                TUESDAY: 2,
                WEDNESDAY: 3,
                THURSDAY: 4,
                FRIDAY: 5,
                SATURDAY: 6,
              };

              const diaAtualTexto = Object.keys(diasSemanaNumber).find(
                (key) => diasSemanaNumber[key] === diaAtual
              );
              const diaAmanha = (diaAtual + 1) % 7;
              const amanhaTexto = Object.keys(diasSemanaNumber).find(
                (key) => diasSemanaNumber[key] === diaAmanha
              );

              if (dadosEmpresa.horarios) {
                const horariosHoje = dadosEmpresa.horarios.filter(
                  (horario: any) => horario.dayOfWeek === diaAtualTexto
                ) || [];

                const horariosAmanha = dadosEmpresa.horarios.filter(
                  (horario: any) => horario.dayOfWeek === amanhaTexto
                ) || [];

                let estaDentroDoHorario = false;
                let proximoHorarioHoje: any = null;

                for (const horario of horariosHoje.sort((a: any, b: any) => a.start.localeCompare(b.start))) {
                  const [horaInicio, minutoInicio] = horario.start.split(":").map(Number);
                  const inicio = horaInicio * 60 + minutoInicio;
                  const fim = inicio + horario.duration;

                  if (horarioAtual >= inicio && horarioAtual <= fim) {
                    estaDentroDoHorario = true;
                    break;
                  }

                  if (horarioAtual < inicio && !proximoHorarioHoje) {
                    proximoHorarioHoje = horario;
                  }
                }

                const valorTotalProdutosNumerico = parseFloat(
                  valorTotalProdutos?.replace(/\./g, "").replace(/\,/g, ".")
                );
                const pedidoMinimoNumerico = parseFloat(
                  dadosEmpresa.pedidoMinimo?.replace(/\./g, "").replace(/\,/g, ".")
                );

                if (listaItemProdutos?.length === 0) {
                  setTextToast("Selecione pelo menos um produto.");
                  setShowToast(true);
                  // } else if (valorTotalProdutosNumerico < pedidoMinimoNumerico) {
                  //   setTextToast(
                  //     "Pedido mínimo de R$ " + (dadosEmpresa.pedidoMinimo || "0,00") + " em produtos."
                  //   );
                  //   setShowToast(true);
                } else if (dadosEmpresa.agendamento) {
                  setShowModalCarrinho(true);
                } else if (!estaDentroDoHorario) {
                  if (proximoHorarioHoje) {
                    setTextToast(
                      `Não é possível realizar o pedido agora. Abrimos hoje às ${formatarHorario(
                        proximoHorarioHoje.start
                      )}.`
                    );
                  } else if (horariosAmanha.length > 0) {
                    const proximoHorarioAmanha = horariosAmanha.sort((a: any, b: any) =>
                      a.start.localeCompare(b.start)
                    )[0];
                    setTextToast(
                      `Estamos fechados. Abrimos amanhã às ${formatarHorario(
                        proximoHorarioAmanha.start
                      )}.`
                    );
                  } else {
                    setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.");
                  }
                  setShowToast(true);
                } else {
                  setShowModalCarrinho(true);
                }
              } else {
                setTextToast("Não é possível realizar o pedido, está fora do horário de funcionamento.");
                setShowToast(true);
              }
            }}
            type="submit"
          >
            Ver carrinho

            <span
              style={{
                backgroundColor: "var(--ion-color-tertiary)",
                color: "var(--ion-color-primary)",
                borderRadius: "12px",
                marginLeft: "8px",
                padding: "2px 6px",
                fontSize: "16px",
                fontWeight: "bold",
                lineHeight: "16px"
              }}
            >
              {listaItemProdutos?.length}
            </span>

          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage >
  );


};

export default Pedido;